import { getAPI } from "utils/http";
import { apis } from "config/urls";

export async function getAllUsers({ token }) {
  return await getAPI(apis.usersAPI, {}, token);
}